import uuid from 'node-uuid';
import {extendObservable, computed, autorun} from 'mobx';
import DndItemStore from './DndItemStore';
import storage from '../libs/storage';

class DndListStore {
  @computed get toJson() {
    // The representation of all the dndLists in storage format
    return this.dndLists.map(dndList => ({
      ...dndList,
      dndItems: dndList.dndItems.map(dndItem => dndItem.id)
    }));
  }
  constructor() {
    extendObservable(this, {
      dndLists: this.load()
    });

    // Create some defaults for demo purposes...
    if (!this.dndLists.length && DndItemStore.dndItems.length >= 3) {
      this.dndLists.push(
        {
          id: uuid.v4(),
          name: 'Meta Data List',
          dndItems: [DndItemStore.dndItems[0], DndItemStore.dndItems[2]],
        },
        {
          id: uuid.v4(),
          name: 'Template Meta Data',
          dndItems: [DndItemStore.dndItems[1]],
        },
      );
    }

    this.persist();
  }
  attachToDndList({dndList, dndItem}) {
    const dndLists = this.dndLists;

    if(!dndList) {
      return;
    }

    this.removeDndItem(dndItem);
    if(dndList.dndItems.indexOf(dndItem) === -1) {
      dndList.dndItems.push(dndItem);
    }
    else {
      console.warn('Already attached dndItem to dndList', dndLists);
    }
  }
  removeDndItem(dndItem) {
    const dndLists = this.dndLists;
    const removeDndList = dndLists.filter((dndList) => {
      return dndList.dndItems.indexOf(dndItem) >= 0;
    })[0];

    if(!removeDndList) {
      return;
    }

    const removeDndItemIndex = removeDndList.dndItems.indexOf(dndItem);

    removeDndList.dndItems.splice(removeDndItemIndex, 1);
  }
  detachFromDndList({dndList, dndItem}) {
    const dndItems = dndList.dndItems;
    const removeIndex = dndItems.indexOf(dndItem);

    if(removeIndex !== -1) {
      dndList.dndItems.splice(removeIndex, 1);
    }
    else {
      console.warn('Failed to remove dndItem from a dndList as it didn\'t exist', this.dndLists);
    }
  }
  move = ({sourceData, targetData}) => {
    const dndLists = this.dndLists;

    const sourceDndList = dndLists.filter((dndList) => {
      return dndList.dndItems.indexOf(sourceData) >= 0;
    })[0];
    const targetDndList = dndLists.filter((dndList) => {
      return dndList.dndItems.indexOf(targetData) >= 0;
    })[0];
    const sourceDndItemIndex = sourceDndList.dndItems.indexOf(sourceData);
    const targetDndItemIndex = targetDndList.dndItems.indexOf(targetData);

    // get rid of the source
    sourceDndList.dndItems.splice(sourceDndItemIndex, 1);

    // and move it to target
    targetDndList.dndItems.splice(targetDndItemIndex, 0, sourceData);
  };
  load() {
    const rawDndLists = storage.get('DndListStore') || [];

    return rawDndLists.map(dndList => ({
      ...dndList,
      dndItems: dndList.dndItems.map(id => DndItemStore.find(id))
    }));
  }
  persist() {
    // Whenever the Json representation of the dndLists changes, store it.
    autorun(() => {
      storage.set('DndListStore', this.toJson);
    });
  }
}

export default new DndListStore()




// WEBPACK FOOTER //
// ./src/stores/DndListStore.js